/* eslint-disable no-unused-expressions */
<template>
  <div v-if="isStaff">
    <div v-if="!selectedBuildingInfo">
      <v-alert type="info">
        Loading building info .... please wait
      </v-alert>
    </div>

    <div v-if="selectedBuildingInfo && loadingReport">
      <v-alert type="info">
        Creating download .... please wait
      </v-alert>
    </div>

    <div v-if="reportErrorMessage">
      <v-alert type="error">Server error: Please refresh page, try again, and if fails again contact support@beringar.co.uk with a
        <br> Error detail: {{ reportErrorMessage }}
      </v-alert>
    </div>

    <div v-if="selectedBuildingInfo && !loadingReport">
      <InsightReportTimeFilters v-model="timeFilters"></InsightReportTimeFilters>
      <p></p>

      <v-card outlined>
        <v-card-title>Data Selection</v-card-title>
        <v-card-text>
          <v-col>
            <v-row>
              <v-col cols="6">
                <v-autocomplete :items="reportGranularityDropdownItems" v-model="reportGranularitySelected"
                                label="Time Granularity"
                                outlined hint="Time Period Per Data Value" persistent-hint></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-switch dense v-model="buildingInfo" label="Building Info"></v-switch>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6">
                <h3>Occupancy</h3>
                <v-switch dense v-model="spaceType" label="Space Type & Floor Data"></v-switch>
                <v-switch dense v-model="occupancyMetrics" label="Metrics"></v-switch>
                <v-switch dense v-model="occupancyMetrics2" label="Metric Ratios"></v-switch>
                <v-switch dense v-model="flowCounts" label="Flow Counts"></v-switch>
                <v-switch dense v-model="occupancyBeringarStandardThresholdCounts"
                          label="Beringar Standard Thresholds"></v-switch>
                <v-switch dense v-model="occupantFirst" label="First Value In Period"></v-switch>
                <v-switch dense v-model="occupantQuartiles" label="Quartiles (Experimental)"></v-switch>
                <v-switch dense v-model="occupancyFrequency" label="Frequency Data"></v-switch>
              </v-col>
              <v-col cols="6">
                <h3>Environmental</h3>
                <v-switch dense v-model="environmental" label="Average Data"></v-switch>
                <v-switch dense v-model="environmentalMinMax" label="Min & Max Data"></v-switch>
                <v-switch dense v-model="environmentalSumCount" label="Count & Sum Data"></v-switch>
                <v-switch dense v-model="thresholdTest1" label="Additional Environmental Thresholds"></v-switch>
                <v-switch dense v-model="environmentalBeringarStandardThresholdCounts"
                          label="Beringar Standard Thresholds"></v-switch>
                <v-switch dense v-model="environmentalFirst" label="First Value In Period"></v-switch>
                <v-switch dense v-model="environmentalQuartiles" label="Quartiles (Experimental)"></v-switch>
              </v-col>
            </v-row>
            <v-row v-if="false">
              <v-col cols="6">
                <h3>Managed Space Selection</h3>
                <v-switch v-model="msFilter" label="Enable Managed Space Filter"></v-switch>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>
      </v-card>
      <p></p>

      <div v-if="msFilter">
        <v-card outlined>
          <v-card-text>
            <v-row>
              <v-col>
                <ManagedSpaceTable
                  v-if="managedSpaces !== []"
                  :managedSpaces="managedSpaces"
                  :show-select="showSelect"
                  @selected="onManangedSpaceSelection"
                ></ManagedSpaceTable>
                <p>{{ managedSelectedCount }} of {{ managedSpaceListCount }} managed spaces selected</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <p></p>
      </div>

      <v-card outlined v-if="resultUrl && !reportErrorMessage">
        <v-card-title>
          Download Ready At Link
        </v-card-title>
        <v-card-text>
          <v-layout justify-center>
            <strong>
              <a :href="resultUrl" target="_blank">Click to download <br>{{ resultUrl }}</a>
            </strong>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-card outlined v-if="!resultUrl">
        <v-card-title>
          Download Request
        </v-card-title>
        <div v-if="numberDays <= maxDays">
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <v-layout justify-center>
                  <v-btn
                    class="layer-btn-large"
                    large tile
                    color="primary"
                    @click="clickLoadReportData"
                  >CREATE DOWNLOAD
                  </v-btn>
                </v-layout>
              </v-col>
              <v-col cols="6">
                <v-layout justify-center>
                  <v-autocomplete :items="urlValidityDropdownItems" v-model="urlValiditySelectedSec"
                                  label="Download Link Validity Time"
                                  outlined hint="Period for Which The Download Link Is Valid"
                                  persistent-hint></v-autocomplete>
                </v-layout>
              </v-col>
            </v-row>
          </v-card-text>
        </div>
        <div v-if="numberDays > maxDays">
          <v-card-text>
            <v-layout justify-center>
              <v-alert type="warning">
                Downloads are currently limited to {{ maxDays }} days
              </v-alert>
            </v-layout>
          </v-card-text>
        </div>
      </v-card>

      <p></p>
      <v-card outlined>
        <v-card-title>
          Debug
        </v-card-title>
        <v-card-text>
          <p>Result url: {{ resultUrl }}</p>
          <p>Start and end dates: {{ startDate }} - {{ endDate }} ({{ numberDays }} days)</p>
          <p>Loading: {{ loadingReport }}</p>
          <p>Next Report Is In Cache: {{ nextReportIsInCache }}</p>
          <p>cachedReport.status {{ cachedReport ? cachedReport.status : '-' }}</p>
          <p>cachedReport.status {{ cachedReport ? cachedReport.error : '-' }} </p>
          <p>Report error message: {{ reportErrorMessage }}</p>
          <!-- <p>Cached Report: {{ cachedReport }}</p>-->
          <p>Report error message: {{ reportErrorMessage }}</p>
          <p>Show Environmental: {{ environmental }}</p>
          <p>Show Occupancy Frequency: {{ occupancyFrequency }}</p>
          <p>Reporting Period Selected: {{ reportGranularitySelected }}</p>
          <p>Show Space Type: {{ spaceType }}</p>
          <p>MS Filter: {{ msFilter }}</p>
          <p>MS Filter Selection: {{ msFilterSelection }}</p>
          <p>Url Validity Selected: {{ urlValiditySelectedSec }}</p>
          <p>Get Next Request Payload: {{ nextRequestPayload }}</p>
        </v-card-text>
      </v-card>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InsightReportTimeFilters from '../components/InsightReportTimeFilters'
import ManagedSpaceTable from '../components/ManagedSpaceTable'

function requestReportForCurrentBuilding (requestPayload) {
  console.log('Report request payload: ' + JSON.stringify(requestPayload))
  let state = this
  state.loadingReport = true
  this.$store.dispatch('fetchBuildingReport2FromServer', requestPayload)
    .then(() => {
      console.log('Report call complete')
      collectBuildingReportFromCache.call(this, requestPayload)
      state.loadingReport = false
    })
    .catch((reason) => {
      console.warn('Report call error ...', reason)
      collectBuildingReportFromCache.call(this, requestPayload)
      state.loadingReport = false
    })
}

function collectBuildingReportFromCache (requestPayload) {
  // console.log('----------------- Collect building report from cache: ' + JSON.stringify(requestPayload))
  console.log('Collect building report from cache')
  let pageState = this
  this.$store.dispatch('collectBuildingReport2FromCache', requestPayload).then(
    function (result) {
      console.log('collectBuildingReport2FromCache')
      // console.log(result)
      if (result) {
        pageState.nextReportIsInCache = true
        pageState.cachedReport = result
      } else {
        pageState.nextReportIsInCache = false
        pageState.cachedReport = null
      }
    })
}

export default {
  name: 'downloader',
  components: {
    InsightReportTimeFilters,
    ManagedSpaceTable
  },
  computed: mapState({
    isStaff: state => state.auth.isStaff,
    buildingId: state => state.building.selectedBuildingId,
    selectedBuildingInfo: function () {
      return this.$store.state.building.selectedBuildingInfo
    },
    managedSpaces: function () {
      return this.$store.state.building.managedSpaces
    },
    startDate () {
      if (this.timeFilters.dateRange.length > 1) {
        if (this.timeFilters.dateRange[0] > this.timeFilters.dateRange[1]) {
          return this.timeFilters.dateRange[1]
        }
      }
      return this.timeFilters.dateRange[0]
    },
    endDate () {
      if (this.timeFilters.dateRange.length > 1) {
        if (this.timeFilters.dateRange[0] < this.timeFilters.dateRange[1]) {
          return this.timeFilters.dateRange[1]
        }
      }
      return this.timeFilters.dateRange[0]
    },
    numberDays: function () {
      let start = new Date(this.startDate)
      let end = new Date(this.endDate)
      return 1 + (Math.abs(end - start) / (1000 * 60 * 60 * 24))
    },
    reportGranularityDropdownItems: function () {
      return [
        // { text: 'Raw Data', value: 1 },
        { text: '5 Minutes', value: 5 },
        { text: 'Quarter Hour', value: 15 },
        { text: 'Half Hour', value: 30 },
        { text: 'Hourly', value: 60 },
        { text: 'Three Hourly', value: 3 * 60 },
        { text: 'Daily', value: 24 * 60 }
      ]
    },
    urlValidityDropdownItems: function () {
      return [
        // { text: '5 Minutes', value: 5 * 60 },
        { text: '30 Minutes', value: 30 * 60 },
        { text: 'One Hour', value: 60 * 60 },
        { text: 'One Day', value: 24 * 60 * 60 }
      ]
    },
    managedSpaceList: function () {
      // var buildingData = this.buildingInfo
      // var readings = this.sensorReadings
      if (!this.managedSpaces) {
        return []
      }
      return this.managedSpaces
    },
    managedSpaceListCount: function () {
      return this.managedSpaces.length
    },
    managedSelectedCount: function () {
      return this.msFilterSelection.length
    },
    nextRequestPayload: function () {
      let startSecInDayFilter = 0
      let endSecInDayFilter = 24 * 60 * 60

      if (this.timeFilters.filterByTimeOfDay) {
        startSecInDayFilter = this.timeFilters.timeOfDayFilterStartSec
        endSecInDayFilter = this.timeFilters.timeOfDayFilterEndSec
      }

      let oneDay = 24 * 60 * 60 * 1000

      let request = {
        'building': this.buildingId,
        'start_time_local': (new Date(Date.parse(this.startDate))).toISOString(),
        'end_time_local': (new Date(Date.parse(this.endDate) + oneDay)).toISOString(),
        'day_of_week_filter_list': this.timeFilters.daysOfWeekFilterValue,
        'start_sec_in_day_filter': startSecInDayFilter,
        'end_sec_in_day_filter': endSecInDayFilter,
        'commands': ['group_by_managedspace_id'],
        'wait_complete_sec': 300,
        'url_expire_time_sec': this.urlValiditySelectedSec,
        'client_download': false,
        'managed_space_filter_list': []
      }
      // 'group_by_30_min_period'
      switch (this.reportGranularitySelected) {
        case 5:
          request.commands.push('group_by_5_min_period')
          break
        case 15:
          request.commands.push('group_by_15_min_period')
          break
        case 30:
          request.commands.push('group_by_30_min_period')
          break
        case 60:
          request.commands.push('group_by_60_min_period')
          break
        case 180:
          request.commands.push('group_by_180_min_period')
          break
        case 1440:
          request.commands.push('group_by_date')
          break
        default:
          request.commands.push('group_by_date')
          break
      }

      if (this.spaceType) {
        request.commands.push('select_managedspace_info')
      }
      if (this.occupancyMetrics) {
        request.commands.push('select_grouped_occupancy_metrics')
      }
      if (this.occupancyMetrics2) {
        request.commands.push('select_grouped_occupancy_metrics2')
      }
      if (this.environmental) {
        request.commands.push('select_grouped_environmental_avg')
      }
      if (this.environmentalMinMax) {
        request.commands.push('select_grouped_environmental_min_max')
      }
      if (this.environmentalSumCount) {
        request.commands.push('select_grouped_environmental_sum_count')
      }
      if (this.occupancyFrequency) {
        request.commands.push('select_grouped_frequency_occupancy')
      }
      if (this.thresholdTest1) {
        request.commands.push('select_grouped_environmental_foleshill_threshold_counts')
      }
      if (this.flowCounts) {
        request.commands.push('select_flow_count')
      }
      if (this.occupantFirst) {
        request.commands.push('select_grouped_occupant_first')
      }
      if (this.occupancyBeringarStandardThresholdCounts) {
        request.commands.push('select_grouped_occupancy_beringar_standard_threshold_counts')
      }
      if (this.environmentalBeringarStandardThresholdCounts) {
        request.commands.push('select_grouped_environmental_beringar_standard_threshold_counts')
      }
      if (this.environmentalFirst) {
        request.commands.push('select_grouped_environmental_first')
      }
      if (this.buildingInfo) {
        request.commands.push('select_building_info')
      }
      if (this.occupantQuartiles) {
        request.commands.push('select_grouped_occupant_quartiles')
      }
      if (this.environmentalQuartiles) {
        request.commands.push('select_grouped_environmental_quartiles')
      }

      // request.commands.push('force_sql_error')

      return request
    },
    resultUrl: function () {
      if (!this.nextReportIsInCache) {
        return undefined
      }
      if (!this.cachedReport) {
        return undefined
      }
      if (!this.cachedReport.report) {
        return undefined
      }
      return this.cachedReport.report.url
    },
    reportErrorMessage: function () {
      if (!this.nextReportIsInCache) {
        return null
      }
      if (!this.cachedReport) {
        return null
      }
      return this.cachedReport.error
    }
  }),
  methods: {
    clickLoadReportData: function () {
      console.log('Load report data pushed')
      requestReportForCurrentBuilding.call(this, this.nextRequestPayload)
    },
    onManangedSpaceSelection: function (newSelection) {
      console.log('Managed space selection updated')
      this.msFilterSelection = newSelection
    },
    clickCountRows: function () {
    }
  },
  watch: {
    nextRequestPayload: {
      deep: true,
      handler: function () {
        console.log('next request payload change - check data in cache')
        console.log('Report request payload: ' + JSON.stringify(this.nextRequestPayload))
        collectBuildingReportFromCache.call(this, this.nextRequestPayload)
      }
    }
  },
  data: () => {
    // eslint-disable-next-line no-labels
    return {
      cachedReport: null,
      nextReportIsInCache: false,
      loadingReport: false,
      environmental: false,
      environmentalMinMax: false,
      environmentalSumCount: false,
      occupancyFrequency: false,
      occupancyMetrics: true,
      occupancyMetrics2: false,
      thresholdTest1: false,
      flowCounts: false,
      occupantFirst: false,
      occupantQuartiles: false,
      environmentalQuartiles: false,
      occupancyBeringarStandardThresholdCounts: false,
      environmentalFirst: false,
      environmentalBeringarStandardThresholdCounts: false,
      buildingInfo: false,
      spaceType: true,
      reportGranularitySelected: 24 * 60,
      urlValiditySelectedSec: 30 * 60,
      msFilter: false,
      msFilterSelection: [],
      showSelect: true,
      maxDays: 40,
      timeFilters: {
        dateRange: ['2021-05-01', '2021-05-07'],
        filterByTimeOfDay: false,
        daysOfWeekFilterValue: [1, 2, 3, 4, 5, 6, 7],
        timeOfDayFilterStartSec: 9 * 60 * 60,
        timeOfDayFilterEndSec: 18 * 60 * 60,
        currentTimezone: 'Europe/London'
      }
    }
  }
}
</script>

<style scoped>

.layer-btn-large {
  font-family: 'NeutrifPro-Bold', serif;
  font-size: 14px;
  letter-spacing: 3px;
}

</style>
